<template>
  <img
    class="vip-level"
    :width="width"
    :height="iconType === 0 ? width : height"
    :src="productLogo"
    v-if="(curData.CompID || curData.CompId || curData.compId) && productLogo"
  />
</template>

<script>
import {DomainService} from '@/libs'

const jinIcon = [DomainService.PublicPath + 'resource/images/icon/jin0.png', DomainService.PublicPath + 'resource/images/icon/jin.png'];
const yinIcon = [DomainService.PublicPath + 'resource/images/icon/yin0.png', DomainService.PublicPath + 'resource/images/icon/yin.png'];
const tongIcon = [DomainService.PublicPath + 'resource/images/icon/tong0.png', DomainService.PublicPath + 'resource/images/icon/tong.png'];

// 会员等级 （金/银/铜/无）
export default {
  name: "vip-level-icon",
  props: {
    iconType: { default: 0 },
    width: {
      default: 56,
      type: [Number, String],
    },
    height: {
      default: 108,
      type: [Number, String],
    },
    curData: {
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    // >=64钻石、>=32金、>=4银、>=2铜 >2无
    productLogo() {
      let vipLevel = (this.curData.CompVipLevel || this.curData.VipLevel||this.curData.vipLevel);
      if ((vipLevel & 64) == 64) {
        return ''
      } else if ((vipLevel & 32) == 32) {
        return jinIcon[this.iconType]
      } else if ((vipLevel & 4) == 4) {
        return yinIcon[this.iconType]
      } else if ((vipLevel & 2) == 2) {
        return tongIcon[this.iconType]
      } else {
        return ''
      }
    },
  },
};
</script>
<style scoped="scoped">
.vip-level-icon {
  object-fit: contain;
  vertical-align: middle;
}
</style>
